<template>
  <div class="agenda-embed">
    <div
      v-if="!agendaUrl"
      class="agenda-embed__state"
    >
      <feather-icon
        icon="AlertTriangleIcon"
        size="32"
      />
      <p class="mt-1 mb-0">
        L'agenda n'est pas configuré pour cet environnement.
      </p>
    </div>

    <iframe
      v-else
      :src="agendaUrl"
      title="Agenda"
      class="agenda-embed__frame"
      allow="clipboard-write"
    />
  </div>
</template>

<script>
import appSettings from '@/appSettings'

export default {
  name: 'AgendaEmbed',
  computed: {
    // ?embed=1 : signale à AtAgenda de faire un login SSO silencieux (pas de redirect
    // pleine page, interdit en iframe). La base URL vient d'appSettings selon l'env.
    agendaUrl() {
      const base = appSettings.getAtagendaURL()
      if (!base) return ''
      return `${base}${base.endsWith('/') ? '' : '/'}?embed=1`
    },
  },
}
</script>

<style scoped lang="scss">
.agenda-embed {
  position: relative;
  width: 100%;
  // Zone de contenu = viewport moins le bandeau haut (navbar + titre/breadcrumb).
  // Valeur de départ concrète, À AJUSTER visuellement (cf. step 8).
  height: calc(100vh - 12rem);

  &__state {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #5A7373;
  }

  &__frame {
    display: block;
    width: 100%;
    height: 100%;
    border: 0;
  }
}
</style>
